import { Grid, Stack } from '@mui/material';
import jsPDF from 'jspdf';
import React from 'react';
import * as Redux from 'react-redux';
import { dateformat, formatDNI } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';
import {
  FAMILY_CONST,
  STUDENT_CONST,
  TEACHER_CONST,
} from '../../../../auth/login/LoginReducer';
import { allCarnetAction } from '../../../../carnet/CarnetAction';
import { captureElementToCanvasHelper } from '../../../../carnet/CarnetHelper';
import { ACTIVO_CARNET, PARAMS_CARNET } from '../../../../carnet/CarnetReducer';
import {
  ALTO_CARNET,
  ANCHO_CARNET,
  PDF_A4,
} from '../../../../carnet/ConstCarnet';
import FrontalCarnet from '../../../../carnet/components/FrontalCarnet';
import LayoutCarnet from '../../../../carnet/components/LayoutCarnet';
import ReverseCarnet from '../../../../carnet/components/ReserveCarnet';
import { rolesArray } from '../../components/SelectFieldRoles';

const CarnetUsuariosPanel = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const carnetStore = Redux.useSelector((state) => state.carnet);

  const usuario = usuariosStore.activo;

  const [loadingPDF, setLoadingPDF] = React.useState(null);

  const [frontalRef, setFrontalRef] = React.useState({});
  const [reverseRef, setReverseRef] = React.useState({});
  const [qrRef, setQrRef] = React.useState({});

  React.useEffect(() => {
    async function fetchData() {
      const payload = { idEntidad: entidadesStore.activo.id };
      dispatch({ type: PARAMS_CARNET, payload });
      const res = await allCarnetAction(dispatch, payload);

      // Buscar el diseño de carnet para docentes
      const diseno = res.data.find((el) => {
        const { perfil } = el;

        console.log(perfil.rol);
        console.log(usuariosStore.activo);

        return perfil && perfil.rol === usuariosStore.activo.rol;
      });

      if (res.data.length > 0) {
        dispatch({ type: ACTIVO_CARNET, payload: diseno });
      }

      if (res.data.length > 0) {
        dispatch({ type: ACTIVO_CARNET, payload: res.data[0] });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadImage = async () => {
    if (!frontalRef.current) {
      notify(`Error de carnet`, { error: true });

      return;
    }

    setLoadingPDF(true);
    notify(`Comenzando la descarga del PDF`);

    const canvasFront = await captureElementToCanvasHelper(frontalRef.current);

    const canvas = await captureElementToCanvasHelper(reverseRef.current);

    const canvasQR = await captureElementToCanvasHelper(qrRef.current);

    const dataCanvaFront = canvasFront.toDataURL('image/jpg');
    const dataCanva = canvas.toDataURL('image/jpg');
    const dataCanvaQR = canvasQR.toDataURL('image/jpg');

    const doc = new jsPDF('portrait', 'pt', PDF_A4);

    const nombre = `${usuariosStore.activo.perfil.pnombre} ${
      usuariosStore.activo.perfil.snombre
        ? usuariosStore.activo.perfil.snombre
        : ''
    } ${usuariosStore.activo.perfil.papellido} ${
      usuariosStore.activo.perfil.sapellido
        ? usuariosStore.activo.perfil.sapellido
        : ''
    } `;

    // doc.text(text, x, y, flags, angle, align);
    doc
      .setFont(undefined, 'bold')
      .setFontSize(14)
      .text('Institución: ' + entidadesStore.activo.nombre, 50, 50);

    doc
      .setFont(undefined, 'normal')
      .setFontSize(14)
      .text('Estudiante: ' + nombre, 50, 70)
      .text(
        'Nro. de Identificación: ' + usuariosStore.activo.perfil.dni,
        50,
        90,
      );

    // doc.addImage(data, type, x, y, width, height, alias, compression, rotation);
    doc.addImage(dataCanvaFront, 'JPEG', 50, 110, ANCHO_CARNET, ALTO_CARNET);
    doc.addImage(dataCanva, 'JPEG', 220, 110, ANCHO_CARNET, ALTO_CARNET);

    doc.setFontSize(14).text('Imagén QR individuales', 50, 400);

    doc.addImage(dataCanvaQR, 'JPEG', 58, 428, 170, 170);
    doc.rect(50, 420, 186, 186); // Agrega un borde alrededor de la imagen

    doc.addImage(dataCanvaQR, 'JPEG', 278, 428, 170, 170);
    doc.rect(270, 420, 186, 186); // Agrega un borde alrededor de la imagen

    doc.addImage(dataCanvaQR, 'JPEG', 58, 628, 100, 100);
    doc.rect(50, 620, 116, 116); // Agrega un borde alrededor de la imagen

    doc.addImage(dataCanvaQR, 'JPEG', 178, 628, 100, 100);
    doc.rect(170, 620, 116, 116); // Agrega un borde alrededor de la imagen

    doc.addImage(dataCanvaQR, 'JPEG', 298, 628, 100, 100);
    doc.rect(290, 620, 116, 116); // Agrega un borde alrededor de la imagen

    doc.addImage(dataCanvaQR, 'JPEG', 418, 628, 100, 100);
    doc.rect(410, 620, 116, 116); // Agrega un borde alrededor de la imagen

    doc.save(
      `PDF-CARNET-${usuario.perfil.pnombre}-${usuario.perfil.papellido}.pdf`,
    );
    setLoadingPDF(true);
  };

  function getRol(rol) {
    if (
      rol === STUDENT_CONST ||
      rol === TEACHER_CONST ||
      rol === FAMILY_CONST
    ) {
      return rolesArray[rol].toUpperCase();
    }
    const usuEntidad = usuEntidadesStore.activo;
    return usuEntidad.perfiles[0].perfil.nombre;
  }

  function getFullnames(isVertical = false) {
    const { pnombre, snombre, papellido, sapellido } = usuario.perfil;

    const validText = (value) => !value || value === '';

    if (validText(snombre) || validText(sapellido)) {
      return isVertical
        ? { names: pnombre, surnames: papellido }
        : { names: `${pnombre} ${papellido}` };
    }

    return {
      names: `${pnombre} ${snombre ? ` ${snombre}` : ''}`,
      surnames: `${papellido} ${sapellido ? ` ${sapellido}` : ''}`,
    };
  }

  if (!carnetStore.activo) {
    return <h3>Falta el diseños del carnet</h3>;
  }

  const carnetDesing = carnetStore.all.find((el) => {
    const { perfil } = el;
    return perfil && perfil.rol === usuario.rol;
  });

  if (!carnetDesing) {
    return <h3>Falta el diseños del carnet</h3>;
  }

  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12} md={12}>
        {usuario && (
          <BotonComponent
            text={isCanrnetDown ? 'Generar carnet' : 'Descargar en formato PDF'}
            loading={loadingPDF}
            click={async () => {
              setFrontalRef(React.createRef());
              setReverseRef(React.createRef());
              setQrRef(React.createRef());

              setLoadingPDF(false);

              await handleDownloadImage();
            }}
            green={!isCanrnetDown}
            blue={isCanrnetDown}
          />
        )}
      </Grid> */}
      <Grid item xs={12} md={12}>
        <Stack direction="row" spacing={2}>
          <LayoutCarnet
            cardRef={frontalRef}
            bg={getFilesArchivos(carnetDesing.fondo)}
          >
            <FrontalCarnet
              notEdit
              data={{
                photo: getFilesArchivos(usuario.perfil.avatar),
                titleText: carnetDesing.titleText,
                subtitleText: carnetDesing.subtitleText,
                titleSeccionText: carnetStore.activo.titleSeccionText,
                titleNivelText: carnetDesing.titleNivelText,
                ...getFullnames(carnetDesing.idEntidad === 8 ? true : false),
                dni: `${usuario.perfil.tipoDni}-${formatDNI(
                  usuario.perfil.dni.trim(),
                )}`,
                periodo: 'PERÍODO 2024-2025',
                nivel: '4TO AÑO - U',
                carrera: 'ELECTRÓNICA',
                profile: getRol(usuario.rol),
                titleAgeText: carnetDesing.titleAgeText,
                age: dateformat(usuario.perfil.fechaNacimiento, {
                  inverse: true,
                }),
                titleBackText: carnetDesing.titleBackText,
                subtitleBackText: carnetDesing.subtitleBackText,
              }}
            />
          </LayoutCarnet>

          <LayoutCarnet
            cardRef={reverseRef}
            bg={getFilesArchivos(carnetDesing.fondoBack)}
            isReverse
          >
            <ReverseCarnet
              qrRef={qrRef}
              data={{
                titleBackText: carnetDesing.titleBackText,
                subtitleBackText: carnetDesing.subtitleBackText,
              }}
              valueCodeqr={usuario.codeqr}
              notEdit
            />
          </LayoutCarnet>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CarnetUsuariosPanel;
